import React from 'react';

import languages from '../../resources/languages';

class NationalReportsListItem extends React.PureComponent {
  renderLinks() {
    const reportLinks = this.props.data.reportLinks;

    return reportLinks.map((item, index) => {
      return (
        <span key={ index }>
          <a href={ item.link } target="_blank">
            { languages[item.language.toLowerCase()] || item.language }
          </a>
          { index === reportLinks.length - 1 || " | " }
        </span>
      );
    });
  }

  render() {
    const attributes = this.props.data.attributes;

    return (
      <tr>
        <td>{ attributes.reportingYear}</td>
        <td>{ attributes.countryName }</td>
        <td>{ this.renderLinks() }</td>
      </tr>
    );
  }
}

export default NationalReportsListItem;



// WEBPACK FOOTER //
// ./src/components/NationalReports/NationalReportsListItem.js